/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { createAboutPageLayoutStyles } from './AboutPageLayout.styles';

type AboutPageLayoutProps = {
  children: any;
};

export function AboutPageLayout(props: AboutPageLayoutProps) {
  const { children } = props;
  const classes = createAboutPageLayoutStyles();

  return <div className={classes.root}>{children}</div>;
}
